export const wealthCopy = {
  fundingBanks: {
    loadFailed: {
      message: "We couldn't load funding banks",
      description: 'Try again, or choose a funding bank now.',
    },
  },
  externalAccounts: {
    preparing: {
      message: 'External account services are still preparing',
      description: 'Your account information is still loading.',
    },
    temporarilyLimited: {
      message: 'External account services are temporarily limited',
      description:
        'Some account services are temporarily limited while we complete routine maintenance. Your information remains secure. Please try again later.',
    },
  },
};
